import axios from "axios";
import { API_BASE } from "../../config/env";
export const FETCH_CAREPROVIDERSV2_FULFILLED = "FETCH_CAREPROVIDERSV2_FULFILLED";
export const FETCH_CAREPROVIDERSV2_REJECTED = "FETCH_CAREPROVIDERSV2_REJECTED";
export const FETCH_CAREPROVIDERSV2_PENDING = "FETCH_CAREPROVIDERSV2_PENDING";
export const RESET_CAREPROVIDERSV2 = "RESET_CAREPROVIDERSV2"

export function careProvidersv2(professionCode,target) {
  const token = localStorage.getItem("accessToken")

  return (dispatch) => {
    dispatch({
      type: "FETCH_CAREPROVIDERSV2",
      payload: axios({
        method: "get",
        url: `${API_BASE}/api/v3/second-opinion/care-providers?professionCode=${professionCode}&target=${target}`,
        headers: {
          "Authorization": "Bearer " + token,
          "Accept-Language": "tr-tr",
          "Client-Id": localStorage.getItem("One-Id"),
          "One-Id": localStorage.getItem("Client-Id"),
          "Content-Type": "application/json",
          "ngrok-skip-browser-warning" : "69920"
        },
      }).then((result) => result.data),
    });
  };
}

export function resetCareProvidersv2() {
  return (dispatch) => {
      dispatch({
          type: "RESET_CAREPROVIDERSV2",
      });
  };
}




